import React from 'react'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../dca.css'

// Only initialize Inertia if the #app root element exists.
const el = document.getElementById('app')

if (el && el.dataset.page) {
  try {
    const initialPage = JSON.parse(el.dataset.page)
    console.log('Starting Inertia with initial page:', initialPage)

    createInertiaApp({
      page: initialPage,
      resolve: (name) => {
        console.log('Resolving component:', name)
        // Check for both .jsx and .tsx files
        const pages = import.meta.glob('../Pages/**/*.{jsx,tsx}', { eager: true })
        
        let page = pages[`../Pages/${name}.jsx`]
        if (!page) {
           page = pages[`../Pages/${name}.tsx`]
        }

        if (!page) {
          throw new Error(`FATAL: Component not found in pages glob: ../Pages/${name}.{jsx,tsx}`)
        }
        
        return page.default || page
      },
      setup({ el, App, props }) {
        createRoot(el).render(<App {...props} />)
      },
    }).catch(err => {
      console.error('Inertia Startup Error:', err)
    })
  } catch (error) {
    console.error('Critical Error Parsing Inertia Page Data:', error)
  }
}
